import { X, Play, Plus, ThumbsUp } from "lucide-react";
import { Link } from "react-router-dom";

const AnimeModal = ({ anime, onClose }) => {
  if (!anime) return null;  

  const imageUrl = anime.banner
    ? anime.banner
    : anime.poster || "/placeholder.svg";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black bg-opacity-70 sm:px-6">
      <div className="relative w-full max-w-lg overflow-hidden bg-black rounded-lg sm:max-w-2xl md:max-w-4xl">
        <button
          onClick={onClose}
          className="absolute z-10 p-2 bg-black rounded-full top-4 right-4 hover:bg-opacity-75"
        >
          <X className="w-6 h-6 text-white" />
        </button>

        <div className="relative h-[50vw] max-h-[350px] sm:max-h-[400px]">
          <img
            src={imageUrl}
            alt={anime.name}
            className="object-cover w-full h-full"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/60 to-black" />

          <div className="absolute bottom-0 left-0 right-0 p-4 space-y-4 sm:p-6 md:p-8">
            <h2 className="text-2xl font-bold text-white sm:text-3xl md:text-4xl">
              {anime.name}
            </h2>

            <div className="flex space-x-3">
              <Link to={`/animes/${anime.id}`}>
                <button className="flex items-center px-4 py-2 text-sm font-semibold text-black bg-white rounded hover:bg-white/90 sm:text-base">
                  <Play className="w-4 h-4 mr-2 sm:h-5 sm:w-5" fill="black" />
                  Ver Episodios
                </button>
              </Link>
              <button className="p-2 rounded-full bg-white/30 hover:bg-white/20">
                <Plus className="w-4 h-4 text-white sm:h-5 sm:w-5" />
              </button>
              <button className="p-2 rounded-full bg-white/30 hover:bg-white/20">
                <ThumbsUp className="w-4 h-4 text-white sm:h-5 sm:w-5" />
              </button>
            </div>
          </div>
        </div>

        {/* Anime information */}
        <div className="p-4 sm:p-6 md:p-8">
          <div className="space-y-4">
            {/* Metadata */}
            <div className="flex flex-wrap items-center space-x-3 text-xs sm:text-sm text-white/70">
              {anime.rating && (
                <span className="font-semibold text-green-500">
                  {Math.round(anime.rating * 10)}% coincidencia
                </span>
              )}
              {anime.releaseYear && (
                <span>{anime.releaseYear}</span>
              )}
              <span className="px-1 border">12+</span>
              <span>Temporadas: {anime.totalSeasons || (anime.seasons && anime.seasons.length) || "?"}</span>
              <span className="px-1 text-xs border border-white/40">HD</span>
            </div>

            <p className="text-base text-white sm:text-lg">
              {anime.description || anime.overview}
            </p>

            {anime.genre && (
              <div className="text-xs sm:text-sm">
                <span className="text-white/50">Género: </span>
                <span className="text-white">
                  {anime.genre}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnimeModal;
